import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { getVerticalName, getVerticalUrl, VERTICAL } from 'lib/utils/store/vehicle'
import { urlWithLangParam } from 'lib/helpers'

import Link from 'components/Link'
import AppContext from 'components/AppContext'

const verticals = [
    VERTICAL.CAR,
    VERTICAL.AUTOTALLI,
    VERTICAL.BIKE,
    VERTICAL.BOAT,
    VERTICAL.MACHINE,
    VERTICAL.PART,
    VERTICAL.CARAVAN,
    VERTICAL.REKKARI,
    VERTICAL.BAANA,
]

const ExternalNavigation = ({ onItemClick }) => {
    const { t, i18n } = useTranslation()

    const links = verticals.map(vertical => {
        let url = getVerticalUrl(t, vertical)
        if (![VERTICAL.AUTOTALLI, VERTICAL.REKKARI, VERTICAL.BAANA].includes(vertical)) {
            url = urlWithLangParam(url, i18n.language)
        }

        const title = getVerticalName(t, vertical)
        return (
            <li key={vertical}>
                <Link
                    to={url}
                    title={title}
                    trackName={vertical}
                    onClick={onItemClick}
                    target="_self"
                >
                    {title}
                </Link>
            </li>
        )
    })

    return (
        <AppContext context="externalNavigation">
            {links}
        </AppContext>
    )
}

ExternalNavigation.propTypes = {
    onItemClick: PropTypes.func,
}

export default ExternalNavigation
